import jAccessApplicationList from '@/views/access/jAccessApplicationList';
import jAccessApplicationDetail from '@/views/access/jAccessApplicationDetail';

import auth from '@/middleware/auth';
import log from '@/middleware/log';
import admin from '@/middleware/admin';

export default [
  {
    path: '/access-application',
    name: 'jAccessApplicationList',
    component: jAccessApplicationList,
    meta: {
      title: 'Access Application',
      middleware: [auth, admin, log],
      layout: 'jSettingWrapper',
    },
  },
  {
    path: '/access-application/detail/:id',
    name: 'jAccessApplicationDetail',
    component: jAccessApplicationDetail,
    meta: {
      title: 'Detail Access Application',
      middleware: [auth, admin, log],
      layout: 'jSettingWrapper',
    },
  },
];



// WEBPACK FOOTER //
// ./src/router/jRouterAccess.js